(function () {
  if (window.flagshipSliderA11y) { return; }

  function slideLabel(slide) {
    var custom = slide.getAttribute('data-a11y-label');
    if (custom) { return custom.trim(); }
    var heading = slide.querySelector('h1, h2, h3, h4');
    if (heading && heading.textContent.trim()) { return heading.textContent.replace(/\s+/g, ' ').trim(); }
    var img = slide.querySelector('img[alt]');
    return img ? (img.getAttribute('alt') || '').trim() : '';
  }

  window.flagshipSliderA11y = function (sw, opts) {
    opts = opts || {};
    if (!sw || !sw.el) { return; }
    var root = sw.el;
    var wrap = sw.wrapperEl;

    if (wrap) { wrap.setAttribute('aria-live', 'off'); }
    sw.on('autoplayStop', function () { if (wrap) { wrap.setAttribute('aria-live', 'off'); } });

    var note = document.createElement('span');
    note.className = 'visually-hidden';
    note.setAttribute('aria-live', 'polite');
    note.setAttribute('aria-atomic', 'true');
    root.appendChild(note);

    function setInert(slide, hide) {
      if (hide) {
        if (!slide.hasAttribute('inert')) { slide.setAttribute('inert', ''); }
      } else if (slide.hasAttribute('inert')) {
        slide.removeAttribute('inert');
      }
    }
    function syncInert() {
      if (opts.inert === false) { return; }
      Array.prototype.forEach.call(sw.slides, function (slide, i) {
        if (opts.visibleOnly) {
          setInert(slide, !slide.classList.contains('swiper-slide-visible'));
        } else {
          setInert(slide, i !== sw.activeIndex);
        }
      });
    }
    syncInert();
    sw.on('slideChange', syncInert);
    if (opts.visibleOnly) {
      sw.on('slideChangeTransitionEnd', syncInert);
      sw.on('resize', syncInert);
    }

    var userMoved = false;
    Array.prototype.forEach.call(root.querySelectorAll('.slide-arrow'), function (arrow) {
      var mark = function () {
        userMoved = true;
        if (typeof opts.onUser === 'function') { opts.onUser(); }
      };
      arrow.addEventListener('click', mark);
      arrow.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { mark(); }
      });
    });

    sw.on('slideChangeTransitionEnd', function () {
      if (!userMoved) { return; }
      userMoved = false;
      var slides = Array.prototype.filter.call(sw.slides, function (s) {
        return !s.classList.contains('swiper-slide-duplicate') && !s.classList.contains('swiper-slide-blank');
      });
      var active = sw.slides[sw.activeIndex];
      var label = active ? slideLabel(active) : '';
      note.textContent = '';
      window.clearTimeout(note.__clearTimer);
      window.setTimeout(function () {
        note.textContent = (sw.realIndex + 1) + ' / ' + slides.length + (label ? ': ' + label : '');
        note.__clearTimer = window.setTimeout(function () { note.textContent = ''; }, 3000);
      }, 120);
    });
  };
})();
